import { gql } from '@apollo/client';

interface ListContextGroupsProps {
    environmentUri: string;
    filter: { samlgroup: string[] };
    normalizeGroups?: boolean;
}
const listContextGroups = ({
    environmentUri,
    filter,
    normalizeGroups,
}: ListContextGroupsProps) => {
    return {
        variables: {
            environmentUri,
            filter,
            normalizeGroups,
        },
        query: gql`
            query listContextGroups(
                $environmentUri: String
                $filter: EnvironmentFilter
                $normalizeGroups: Boolean
            ) {
                listContextGroups(
                    environmentUri: $environmentUri
                    filter: $filter
                    normalizeGroups: $normalizeGroups
                )
            }
        `,
    };
};

export default listContextGroups;
